import { render } from "./PokemonOptions.vue?vue&type=template&id=13be81f7&scoped=true"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=13be81f7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13be81f7"

export default script